import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { Col, Row, Dropdown } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import Table, { RowType } from '../../Shared/CustomTable';
import { CONFIRMATION_MODAL_CONFIG } from '../../../config/constants';
import { COMBINE_DRILLS, DEFAULT_EVENT_VALIDATION_STATE, DRILL_POSITIONS, EVENT_END_LABEL, EVENT_START_LABEL, LIVE_PRACTICE, PAST_PRACTICE} from '../../../config/constants';
import { useRouter } from '../../../helpers/customHooks';
import { useDataEventsState, usePlayersDispatch, usePracticeDataUpdateDispatch, useSearchesState } from '../../../store/hooks';
import { useManageDispatch } from 'store/hooks/manage';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import { Manage, CombineEventsType } from 'config/commonTypes';
import { eventsTableTimeValidator, isTMSavableCombine, text_truncate } from 'helpers';
import CombineHeader from './CombineHeader';
import EditableTimeCombine from './EditableTimeCombine';
import Loader from 'components/Shared/Loader';
import EditableFieldCombine from './EditableFieldCombine';
import { getCombinePlayersSearchData } from 'store/actions';
import { CombineDrillOptionsType } from 'store/types';
import { SERVER } from 'config/server.config';
import ConfirmationModalCombine from 'components/Shared/Modals/ConfirmationModalCombine';
import { playerInfo } from './types';
type updateQueueProps ={
  queue: string[];
  fetching: number;
}
type TimestampMessages = {
  [key: string]: string;
};
type EventValidationState = {
  [EVENT_START_LABEL]: TimestampMessages;
  [EVENT_END_LABEL]: TimestampMessages;
};
let indexSearch = 0;

const CombineLogger = () => {
  const drillOne = 'drillOnest';
  const drillTwo = 'drillTwost';
  const { dataEvent, data:manageData, meta } = useDataEventsState();
  const { playersCombineData: playersCombine } = useSearchesState();
  const practice = manageData.manage;
  const {pathname:path} = useRouter();
  const [theGameId, setTheGameId] = useState(path.split('/')[3]);
  const eventId = meta._id;
  const gameId = meta.gameId === theGameId? meta.gameId : theGameId;
  const league = meta.league;
  const teamId = meta.homeTeam.teamId;
  const players = playersCombine[teamId];
  const [filteredPlayersOne, setFilteredPlayersOne] = useState(players);
  const [filteredPlayersTwo, setFilteredPlayersTwo] = useState(players);
  const {updatePractice, updateCombineEvent} = useManageDispatch();
  const { getPractice } = useManageDispatch();
  const dispatch = useDispatch();
  const { noSave } = usePracticeDataUpdateDispatch();
  const [editable, setEditable] = useState(false);
  const [eventsValidation, setEventsValidation] = useState<EventValidationState>(DEFAULT_EVENT_VALIDATION_STATE);
  const [updateQueue, setUpdateQueue] = useState<updateQueueProps>({ queue: [], fetching: 0 });
  const [practiceCopy, setPracticeCopy] = useState<Manage>(JSON.parse(JSON.stringify(practice)));
  const [textSearchedEdited, setTextSearchedEdited] = useState('');
  const [detectedPlayersEdit, setDetectedPlayersEdit] = useState<JSX.Element[]>([]);
  const rendersCounter = useRef(0);
  const [disableStartOne, setDisableStartOne]= useState(false);
  const [disableStartTwo, setDisableStartTwo]= useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isCustomDrillOne, setIsCustomDrillOne] = useState(false);
  const [isCustomDrillTwo, setIsCustomDrillTwo] = useState(false);
  const [comonDrillsSelectedOne, setComonDrillsSelectedOne] = useState(false);
  const [comonDrillsSelectedTwo, setComonDrillsSelectedTwo] = useState(false);

  useEffect(() => {
    if (!editable && !isTMSavableCombine(eventsValidation)) {
      setEventsValidation(DEFAULT_EVENT_VALIDATION_STATE);
    }
  }, [editable]);

  useEffect(() => {
    setTheGameId(path.split('/')[3]);
    getPractice(eventId, league!);
  }, [path]);

  useEffect(() => {
    dispatch(getCombinePlayersSearchData(teamId, league));
  }, []);

const countShow = 20;

  useEffect(() => {
    setDetectedPlayersEdit([]);
    indexSearch = 0;
    if (textSearchedEdited) {
      addSearchPlayersEdited(countShow, []);
    }
  }, [textSearchedEdited, players]);

  const correctHour = (am:boolean, hour:number) => {
    if (am === true) {
      if (hour === 12) {
        hour = 0;
      }
    } else {
      if (hour !== 12) {
        hour += 12;
      }
    }
    return hour;
  };

  const handleChange = ( target : string, drillId: number) => {
    if(drillId === 3){
      setTextSearchedEdited(target);
    }
  };

  
  const changeCustomDrill = (drillId: number) =>{
    if(drillId === 1){
      setIsCustomDrillOne(!isCustomDrillOne);
      setCurrentDrillOne('SELECT DRILL');
      setCustomDrillOneAux('');
    }else{
      setIsCustomDrillTwo(!isCustomDrillTwo);
      setCurrentDrillTwo('SELECT DRILL');
      setCustomDrillTwoAux('');
    }
   };

  const handleChangePlayerInfo = (player:playerInfo) =>{
    setTextSearchedEdited('');
    const now = new Date().getTime();
    const newPractice = JSON.parse(JSON.stringify(practiceCopy));
    const newCombineIndex = newPractice.combineEvents ? newPractice.combineEvents.findIndex((event:CombineEventsType)=> event.session_id === editDrillId.event.session_id) : -1;
    if(newCombineIndex !== -1){
    newPractice.combineEvents[newCombineIndex].esbid = player.extra_data.esbId;
    newPractice.combineEvents[newCombineIndex].entity_id = player.id;
    newPractice.combineEvents[newCombineIndex].modified = 1;
    newPractice.combineEvents[newCombineIndex].timestamp = now;
    if(player.extra_data.positionGroup && player.extra_data.positionGroup !== ""){
      newPractice.combineEvents[newCombineIndex].jerseyNumber = player.extra_data.positionGroup === "WR"?"WO"+player.extra_data.jerseyNumber.toString() 
      : player.extra_data.positionGroup+player.extra_data.jerseyNumber.toString();
    }else{
      newPractice.combineEvents[newCombineIndex].jerseyNumber = player.extra_data.position === "WR"?"WO"+player.extra_data.jerseyNumber.toString()
      : player.extra_data.position + player.extra_data.jerseyNumber.toString() ;
    }
    setPracticeCopy(newPractice);
    }
    
  };

  const addSearchPlayersEdited = (amount: number, detecteds: JSX.Element[]) => {
    let count = 0;
    const newDetectedPlayers:any = []; //TO DO CHECK TYPE
    const detectedPlayerInfo = [];
    const matchedPlayers = []; 
    for (; indexSearch < players.length; ++indexSearch) {
      if (count >= amount) {
        break;
      }
      const player = players[indexSearch]; 
      
      if (player.type === "player" || player.extra_data.jerseyNumber) {
        if (player.extra_data.jerseyNumber.toString().indexOf(textSearchedEdited.toLowerCase()) === -1) {
          continue;
        }
        matchedPlayers.push(player);
      }
    }
    matchedPlayers.sort((a, b) => a.extra_data.jerseyNumber - b.extra_data.jerseyNumber);
    matchedPlayers.forEach((player) => {
      ++count;
      newDetectedPlayers.push(
        <span
          className={'output-search-box-label'}
          key={player.name}
          onClick={() => {
            handleChangePlayerInfo(player);
            setDetectedPlayersEdit([]);
          }}
        >
          {player.name} (
          {!player.extra_data.positionGroup || player.extra_data.positionGroup === ""
            ? player.extra_data.position === "WR"
              ? "WO"
              : player.extra_data.position
            : player.extra_data.positionGroup === "WR"
            ? "WO"
            : player.extra_data.positionGroup}
          -{player.extra_data.jerseyNumber})
        </span>
      );
      detectedPlayerInfo.push({
        name: player.name,
        namespaced_id: player.namespaced_id,
        extra_data: player.extra_data,
      });
    });
  
    setDetectedPlayersEdit([...detecteds, ...newDetectedPlayers]);
  };
  
  const handleEventsTimeChange = (key:string, eTime: string, hour:number, minute:number, second:number, am:boolean, index?:number) => {
    const now = new Date().getTime();
    hour = correctHour(am, hour);
    let inputIndex;
    if(!index){
      inputIndex = 0;
    }else{
      inputIndex = index;
    }
    let newTime;
    if(practiceCopy.combineEvents){
      newTime = practiceCopy.combineEvents[inputIndex as number][eTime] as number;
      newTime = DateFns.setHours(newTime, hour || 0);
      newTime = DateFns.setMinutes(newTime, minute || 0);
      newTime = DateFns.setSeconds(newTime, second || 0);
      const newPractice = JSON.parse(JSON.stringify(practiceCopy));
      if(newPractice.combineEvents){
        newPractice.combineEvents[inputIndex as number][eTime] = newTime.getTime();
        newPractice.combineEvents[inputIndex as number].modified = 1;
        newPractice.combineEvents[inputIndex as number].timestamp = now;
        setPracticeCopy(newPractice);
        validatePeriodsTimeChange(inputIndex as number, newPractice);

      } 
    }
   
  };

const validatePeriodsTimeChange = (index:number, updatedPeriods:Manage) => {
  const unmutedValidation:EventValidationState = { ...eventsValidation };
    const args:[number, EventValidationState, Manage] = [index, unmutedValidation, updatedPeriods];
    unmutedValidation[EVENT_START_LABEL] = validateTimeChanges(EVENT_START_LABEL, ...args);
    unmutedValidation[EVENT_END_LABEL] = validateTimeChanges(EVENT_END_LABEL, ...args);
    setEventsValidation(unmutedValidation);
};

  const validateTimeChanges = (key: keyof EventValidationState, index:number, unmutedValidation:EventValidationState, updatedPeriods:Manage) => {
    const labeledPeriod = { ...unmutedValidation[key] };
    const periodVal = eventsTableTimeValidator(key, index, updatedPeriods);
    if (periodVal) {
      labeledPeriod[index] = periodVal;
    } else if (labeledPeriod[index]) {
      delete labeledPeriod[index];
    }
    return labeledPeriod;
  };

  const newPractice = (practice:Manage) => {
    const newPractice = JSON.parse(JSON.stringify(practice));
      if (newPractice.drills) {
        for (let i = 0; i < newPractice.drills.length; ++i) {
          newPractice.drills[i]['drillId'] = i;
        }
      }
      return newPractice;
    };
  const shouldSave = useSelector((state: RootState) => state.practiceDataUpdate.noSave);
  const [currentPractice, setCurrentPractice] = useState<Manage>(newPractice(practice));

  const isInprogressOne = practiceCopy.combineEvents?.some((event:CombineEventsType) => { 
    if(event.id === drillOne){
      return true;
    }else{
      return false;
    }    
  });
    const isInprogressTwo = practiceCopy.combineEvents?.some((event:CombineEventsType) => { 
      if(event.id === drillTwo){
        return true;
      }else{
        return false;
      }
      
    });

  useEffect(() => {
    let drillOneStatus;
    let drillTwoStatus;
    // END EVENTS WHEN PRACTICE ENDS
    rendersCounter.current++;
  if (practiceCopy.combineEvents && practiceCopy.combineEvents.length >0 && (meta.type === PAST_PRACTICE) && (isInprogressOne || isInprogressTwo)) {
    practiceCopy.combineEvents.map((event:CombineEventsType)=>{
      if(event.id === 'drillOnest'){
        drillOneStatus = 'drillOneend';
      }
      if(event.id === 'drillTwost'){
        drillTwoStatus = 'drillTwoend';
      }
    });
    if(drillOneStatus !== undefined){
     handleSaveClick('', drillOneStatus);
    }
    if(drillTwoStatus !== undefined){
     handleSaveClick('', drillTwoStatus);
    }
    
  }
}, [meta.type, meta.gameId]);


    const drillOneLabel = practiceCopy.combineEvents?.find((event:CombineEventsType) => { 
      if(event.id === drillOne){
        return event.drill;
      }else{
        return false;
      }
      
    });
    const drillTwoLabel = practiceCopy.combineEvents?.find((event:CombineEventsType) => { 
      if(event.id === drillTwo){
        return event.drill;
      }else{
        return false;
      }
      
    });

    const [drillOneSt, setDrillOneSt] = useState(isInprogressOne? isInprogressOne : false);
    const [drillTwoSt, setDrillTwoSt] = useState(isInprogressTwo? isInprogressTwo : false);
    const [currentPosOne, setCurrentPosOne] = useState(0);
    const [currentPosTwo, setCurrentPosTwo] = useState(0);
    const [positionOne, setPositionOne] = useState('SELECT POSITION');
    const [positionTwo, setPositionTwo] = useState('SELECT POSITION');
    const [currentDrillOne, setCurrentDrillOne] = useState('SELECT DRILL');
    const [currentDrillTwo, setCurrentDrillTwo] = useState('SELECT DRILL');
    const [currentDrillOneType, setCurrentDrillOneType] = useState('');
    const [currentDrillTwoType, setCurrentDrillTwoType] = useState('');
    const [drOneJerseyNumber, setDrOneJerseyNumber] = useState('');
    const [drTwoJerseyNumber, setDrTwoJerseyNumber] = useState('');
    const [customDrillOneAux, setCustomDrillOneAux] = useState<string>('');
    const [customDrillTwoAux, setCustomDrillTwoAux] = useState<string>('');
   

    useEffect(() => {
      setIsUpdating(false);
      setCurrentPractice(newPractice(practice));    
      setPracticeCopy(JSON.parse(JSON.stringify(practice)));  
    }, [practice]);

    useEffect(() => {
      if(positionOne === 'SELECT POSITION'){
        setCurrentDrillOne('SELECT DRILL');
      }
      if(drillOneLabel){
        setCurrentDrillOne(drillOneLabel.drill);
        setDrillOneSt(true);
      }else{
        setDrillOneSt(false);
      }
    }, [drillOneLabel]);

    useEffect(() => {
      if(positionTwo === 'SELECT POSITION'){
        setCurrentDrillTwo('SELECT DRILL');
      }
      if(drillTwoLabel){
        setCurrentDrillTwo(drillTwoLabel.drill);
        setDrillTwoSt(true);
      }else{
        setDrillTwoSt(false);
      }
    }, [drillTwoLabel]);
    
    const EventUniqueSessionId = () => {
      const generateRandomString = () => {
          const array = new Uint32Array(1);
          crypto.getRandomValues(array);
          return array[0].toString(36).padStart(7, '0').substring(0, 4).toUpperCase();
      };
      const timestamp = Date.now().toString(36).toUpperCase();
      const randomString = generateRandomString();
      const uniqueId = timestamp + randomString;
      return uniqueId;
  };
    const updateEventsPractice = useCallback(async (label, drill) => {
      let playerOneInfo: playerInfo | undefined;
      let playerTwoInfo: playerInfo | undefined;
      let jerseyNumberOne = drOneJerseyNumber;
      let jerseyNumberTwo = drTwoJerseyNumber;
      const now = new Date().getTime();
      if(drill === 'drillOnest'){
        if(drOneJerseyNumber.length === 1 ){
          jerseyNumberOne='0'+jerseyNumberOne;
          playerOneInfo = filteredPlayersOne.find(player => player.extra_data.jerseyNumber.toString() === jerseyNumberOne);
        }else{
          playerOneInfo = filteredPlayersOne.find(player => player.extra_data.jerseyNumber.toString() === jerseyNumberOne);
        }
        const eventSessionId = EventUniqueSessionId();
        setDrillOneSt(true);
        let combineEvent: CombineEventsType; //NEW OBJECT
      if (!practiceCopy.combineEvents) {
        practiceCopy.combineEvents = []; 
      }
      const now = new Date().getTime();
      if(playerOneInfo !== undefined){
      combineEvent={ id:drill, type: currentDrillOneType, drill: currentDrillOne, timestamp: now, stTime: now,
        jerseyNumber: positionOne === 'SELECT POSITION'? '': positionOne + jerseyNumberOne,
        esbid: playerOneInfo.extra_data.esbId, entity_id: playerOneInfo.id, modified: 0, group_number: playerOneInfo.extra_data.group_number,
        session_id: eventSessionId, isCustom: isCustomDrillOne };
      }else{
        combineEvent={ id:drill, type: currentDrillOneType, drill: currentDrillOne, timestamp: now, stTime: now,
          jerseyNumber: positionOne === 'SELECT POSITION'? '': positionOne + jerseyNumberOne,
          esbid: '', entity_id:'', modified: 0, group_number: '', session_id: eventSessionId, isCustom: isCustomDrillOne };
      }
        practiceCopy.combineEvents.push(combineEvent);
      }else if (drill === 'drillTwost'){
        if(drTwoJerseyNumber.length === 1 ){
          jerseyNumberTwo='0'+jerseyNumberTwo;
          playerTwoInfo = filteredPlayersTwo.find(player => player.extra_data.jerseyNumber.toString() === jerseyNumberTwo);
        }else{
          playerTwoInfo = filteredPlayersTwo.find(player => player.extra_data.jerseyNumber.toString() === jerseyNumberTwo);
        }
        const eventSessionId = EventUniqueSessionId();
        setDrillTwoSt(true);
        let combineEvent:CombineEventsType; //NEW OBJECT
        if (!practiceCopy.combineEvents) {
          practiceCopy.combineEvents = [];
        }
        const now = new Date().getTime();
        if(playerTwoInfo !== undefined){
        combineEvent = { id:drill, type: currentDrillTwoType, drill: currentDrillTwo,  timestamp: now,  stTime: now, 
          jerseyNumber: positionTwo === 'SELECT POSITION'? '': positionTwo + jerseyNumberTwo,
          esbid: playerTwoInfo.extra_data.esbId, entity_id: playerTwoInfo.id, modified: 0, group_number: playerTwoInfo.extra_data.group_number,
          session_id: eventSessionId, isCustom: isCustomDrillTwo};
          practiceCopy.combineEvents.push(combineEvent);
        }else{
          combineEvent = { id:drill, type: currentDrillTwoType, drill: currentDrillTwo,  timestamp: now,  stTime: now, 
            jerseyNumber: positionTwo === 'SELECT POSITION'? '': positionTwo + jerseyNumberTwo,
            esbid: '', entity_id: '', modified: 0, group_number: '', session_id: eventSessionId, isCustom: isCustomDrillTwo };
            practiceCopy.combineEvents.push(combineEvent);
        }

      }else if (drill === 'drillOneend'){
        setDrillOneSt(false);
        let finishedCombineEvent: Partial<CombineEventsType> = {};
        practiceCopy.combineEvents = practiceCopy.combineEvents?.map((event:CombineEventsType)=>{
          if(event.id === 'drillOnest'){
            event.endTime = now;
            event.timestamp = now;
            event.id = drill;
            finishedCombineEvent = event;
          }
          return event;
        });
        fetch(SERVER.CREATE_COMBINE_OBJECT(gameId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(finishedCombineEvent)
        })
        .then((response) => response.json())
        .then((json) => {
          const newCombineEvent = JSON.parse(json.results[0]);
          const newCombineIndex = practiceCopy.combineEvents ? practiceCopy.combineEvents.findIndex(event=> event.session_id === finishedCombineEvent.session_id) : -1;
          if(newCombineIndex !== -1){
            if(practiceCopy.combineEvents){
              practiceCopy.combineEvents[newCombineIndex].event_id = newCombineEvent.event_id;
            }
          }
        });
        clearDrOneJersey();
      }else{
        setDrillTwoSt(false);
        let finishedCombineEvent:Partial<CombineEventsType> = {};
        practiceCopy.combineEvents = practiceCopy.combineEvents?.map((event:CombineEventsType)=>{
          if(event.id === 'drillTwost'){
            event.endTime = now;
            event.timestamp = now;
            event.id = drill;
            finishedCombineEvent = event;
          }
          return event;
        });
        fetch(SERVER.CREATE_COMBINE_OBJECT(gameId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(finishedCombineEvent)
        })
        .then((response) => response.json())
        .then((json) => {
          const newCombineEvent = JSON.parse(json.results[0]);
          const newCombineIndex = practiceCopy.combineEvents ? practiceCopy.combineEvents.findIndex(event=> event.session_id === finishedCombineEvent.session_id) : -1;
          if(newCombineIndex !== -1){
            if(practiceCopy.combineEvents){
              practiceCopy.combineEvents[newCombineIndex].event_id = newCombineEvent.event_id;
            }
          }
        });
        clearDrTwoJersey();
      }
      setCurrentPractice(practiceCopy);
    }, [dataEvent.meta.type, eventId, league, practice, updatePractice]);

    useEffect(() => {
      if (updateQueue.queue.length && !updateQueue.fetching) {
        setUpdateQueue(prevState => ({ ...prevState, fetching: 2 }));
        updateEventsPractice(updateQueue.queue[0], updateQueue.queue[1]).then(() => {
          setUpdateQueue(prevState => ({ queue: prevState.queue.slice(2), fetching: 0 }));
        });
      }
    }, [updateQueue]);
    
    const handleSaveClick = (label:string, drill:string) => {
      
      setUpdateQueue(prevState => ({ queue: [...prevState.queue, label, drill], fetching: prevState.fetching }));
    };

    const handlePostionChange = (position:string, id: number) => {
      if(id === 1){
        setFilteredPlayersOne(players.filter(player => player.extra_data.positionGroup === position ||  player.extra_data.position === position ));
        setPositionOne(position);
        setCurrentPosOne(COMBINE_DRILLS.findIndex(x=> x.groupSelected === position));
        if(!comonDrillsSelectedOne)setCurrentDrillOne('SELECT DRILL');
        setCustomDrillOneAux('');
      }else{
        setFilteredPlayersTwo(players.filter(player => player.extra_data.positionGroup === position ||  player.extra_data.position === position ));
        setPositionTwo(position);
        setCurrentPosTwo(COMBINE_DRILLS.findIndex(x=> x.groupSelected === position));
        if(!comonDrillsSelectedTwo)setCurrentDrillTwo('SELECT DRILL');
        setCustomDrillTwoAux('');
      }
      
    };
    const handleDrillOneChange = (drill:CombineDrillOptionsType | string) => {
      if(typeof drill === 'string'){
        setCurrentDrillOne(drill);
        setCurrentDrillOneType('Skill Drills - '+ positionOne);
        setCustomDrillOneAux(drill);
      }else{
        setCurrentDrillOne(drill.drill);
        setCurrentDrillOneType(drill.drillType);
        setCustomDrillOneAux('');
      }
      
    };

    const handleDrillTwoChange = (drill:CombineDrillOptionsType | string) => {
      if(typeof drill === 'string'){
        setCurrentDrillTwo(drill);
        setCurrentDrillTwoType('Skill Drills - '+ positionTwo);
        setCustomDrillTwoAux(drill);
      }else{
        setCurrentDrillTwo(drill.drill);
        setCurrentDrillTwoType(drill.drillType);
        setCustomDrillTwoAux('');
    }

    };

    const handleDeleteEvent =  (event: CombineEventsType) =>{
      setDisableStartOne(false);
      setDisableStartTwo(false);
      const now = new Date().getTime();
      event['deleted'] = 1;
      event.timestamp= now;
      setModalShow(0);
      setEditDrillId({event_id:'', event: {}});
      if(event.event_id)
      updateCombineEvent(gameId, event, event.event_id, eventId, league!);
    };

    const handleJerseyNumberChange = (event:React.ChangeEvent<HTMLInputElement>, drillId:number) => {
      const newPractice = JSON.parse(JSON.stringify(practiceCopy));
      handleChange(event.target.value.replace(/\D/g, ''),3);
      newPractice.combineEvents[drillId].jerseyNumber = event.target.value.replace(/\D/g, '').toUpperCase() ;
      newPractice.combineEvents[drillId].esbid = "";
      newPractice.combineEvents[drillId].entity_id = "";
      setPracticeCopy(newPractice);
    };
    const handleEventType = (selectedDrill:{ drill: string; drillType: string }, drillId:number) => {
      const now = new Date().getTime();
      noSave(true);
      const newPractice = JSON.parse(JSON.stringify(practiceCopy));
      newPractice.combineEvents[drillId].drill = selectedDrill.drill;
      newPractice.combineEvents[drillId].type = selectedDrill.drillType;
      newPractice.combineEvents[drillId].modified= 1;
      newPractice.combineEvents[drillId].timestamp= now;
      setPracticeCopy(newPractice);
  
    };

    const handleUpdateDrOneJersey = (e:React.MouseEvent<HTMLButtonElement>) =>{
      const limit = 3;
      setDrOneJerseyNumber(drOneJerseyNumber.concat(e.currentTarget.name).slice(0,limit));
      handleChange(drOneJerseyNumber.concat(e.currentTarget.name).slice(0,limit), 1);
    };

    const clearDrOneJersey = () =>{
      setDrOneJerseyNumber('');
    };

    const handleUpdateDrTwoJersey = (e:React.MouseEvent<HTMLButtonElement>) =>{
      const limit = 3;
      setDrTwoJerseyNumber(drTwoJerseyNumber.concat(e.currentTarget.name).slice(0,limit));
      handleChange(drTwoJerseyNumber.concat(e.currentTarget.name).slice(0,limit), 2);
    };

    const handleReviewFlag = (event:CombineEventsType, index:number) =>{
      const now = new Date().getTime();
      const newPractice = JSON.parse(JSON.stringify(practiceCopy));
      if(event.review){
        newPractice.combineEvents[index].review = false;
        event['review'] = false;
      }else{
        newPractice.combineEvents[index].review = true;
        event['review'] = true;
      }
      setPracticeCopy(newPractice);
      setCurrentPractice(newPractice);
      if(event.event_id){
        updateCombineEvent(gameId, event, event.event_id, eventId, league!);
      }
    };

    const clearDrTwoJersey = () =>{
      setDrTwoJerseyNumber('');
    };
    //POSITION SELECTOR
    const drillOnePosition = DRILL_POSITIONS.types.map((type, index) => (
      <Dropdown.Item key={index} onClick={() => handlePostionChange(type,1)} >{type}</Dropdown.Item>
    ));

    const drillTwoPosition = DRILL_POSITIONS.types.map((type, index) => (
      <Dropdown.Item key={index} onClick={() => handlePostionChange(type,2)} >{type}</Dropdown.Item>
    ));

    const drillOneFilter = COMBINE_DRILLS[comonDrillsSelectedOne? 10 :currentPosOne].options.map((type, index) => (
      <Dropdown.Item key={index} onClick={() => handleDrillOneChange(type)} >{type.drill}</Dropdown.Item>
    ));
    
    const drillTwoFilter = COMBINE_DRILLS[comonDrillsSelectedTwo? 10 :currentPosTwo].options.map((type, index) => (
      <Dropdown.Item key={index} onClick={() => handleDrillTwoChange(type)} >{type.drill}</Dropdown.Item>
    ));

    const headers = [
    { content: 'NO.', style: { width: '74px', verticalAlign: 'top' }, class: 't-ll', isOrderly: !editable },
    { content: 'DRILL NAME', style: { width: '135px', verticalAlign: 'top' }, class: 't-ll', isOrderly: !editable },
    { content: 'START TIME', style: { width: '135px', verticalAlign: 'top' }, class: 't-ll',isOrderly: !editable },
    { content: 'END TIME', style: { width: '135px', verticalAlign: 'top' }, class: 't-ll', isOrderly: !editable, },
    { content: 'ACTION', style: { width: '127px', verticalAlign: 'top' },  isOrderly: !editable, }
    ];
    const [editDrillId, setEditDrillId] = useState<{event_id:string, event: Partial<CombineEventsType>}>({ event_id: '', event:{} });
    const rows:RowType[] = [];
    if(practiceCopy.combineEvents){
      //@ts-ignore
     practiceCopy.combineEvents.forEach((event, index)=>{
        if(event.id && (!event.deleted || event.deleted === 0)){
          const isEditable = editDrillId.event_id === event.event_id;
          const startTimestampsMessages = { ...eventsValidation[EVENT_START_LABEL] };
          const endTimestampsMessages = { ...eventsValidation[EVENT_END_LABEL] };
          const positionDrill = (event.jerseyNumber).match(/[a-zA-Z]+/g);
          const positionIndex = positionDrill? COMBINE_DRILLS.findIndex(x=> x.groupSelected === positionDrill[0]): -1;
          rows.push({
            columns: [
              {
                content: event.jerseyNumber,
                style: event.id == drillOne ? { width: '74px', background: 'rgb(8,164,252)', color: 'white', fontWeight: 'bold'} : event.id === drillTwo ? 
                { width: '74px', background: 'rgb(32, 36, 172)', color: 'white', fontWeight: 'bold'} : 
                event.review? { width: '74px', background: '#d4f0ff', color: 'black', fontWeight: 'bold'}:
                event.esbid === "" || event.entity_id === ""? { width: '74px', background: 'rgb(255 226 0 / 26%)', color: 'black', fontWeight: 'bold'}:
                event.modified? { width: '74px', background: 'rgb(152 225 144 / 79%)', color: 'black', fontWeight: 'bold'} : { width: '74px'}, 
                class: 't-ll tt-qq-0', 
                print: (content: string) => <><EditableFieldCombine
                itemId={index as number} editable={isEditable} text={isEditable? content === ''? '-'  : content : content === ''? '-'  : '#'+text_truncate(content, 8)}
                handleChange={handleJerseyNumberChange}
                editedText={textSearchedEdited}
              />
              { !isEditable && (event.id !== drillOne && event.id !== drillTwo)?
              <div>
               <button style={ event.review? {border: 'none', background: 'none', position: 'absolute', fontSize:'22px', right:'-16px', top: '9px', color: '#007ABA'}
                      : {border: 'none', background: 'none', position: 'absolute', fontSize:'22px', right:'-16px', top: '9px'}}
                      className='mdi mdi-alert-box-outline' onClick={()=>handleReviewFlag(event, index)}/>
                      </div>
                      :
                      null
              }
                      
              {(detectedPlayersEdit.length > 0)&& isEditable && (
                  <div
                    style={{position: 'absolute', background: 'white', maxHeight:'200px', width: '200px', zIndex: 10000, overflowY: 'auto'}}>
                    
                    <div>{detectedPlayersEdit}</div>
                  </div> 
          )}
              </>,
             order: (contentA, contentB) => {
                const matchA = contentA.match(/^([a-zA-Z]+)(\d*)$/);
                const matchB = contentB.match(/^([a-zA-Z]+)(\d*)$/);

                if (!matchA || !matchB) return 0;

                const prefixA = matchA[1];
                const prefixB = matchB[1];
                const numStrA = matchA[2];
                const numStrB = matchB[2];

                const numA = numStrA === "" ? null : parseInt(numStrA, 10);
                const numB = numStrB === "" ? null : parseInt(numStrB, 10);
                if (prefixA !== prefixB) {
                    return prefixA.localeCompare(prefixB);
                }
                if (numA === null) return -1;
                if (numB === null) return 1;
                if (numA !== numB) {
                    return numA - numB;
                }
                return numStrA.localeCompare(numStrB);
              },     
              
              },
              {
                content: event.drill,
                style: event.id == drillOne ? { width: '135px', background: 'rgb(8,164,252)', color: 'white', fontWeight: 'bold'} : event.id === drillTwo ? 
                { width: '135px', background: 'rgb(32, 36, 172)', color: 'white', fontWeight: 'bold'} :
                event.review? { width: '135px', background: '#d4f0ff', color: 'black', fontWeight: 'bold'}:
                event.esbid === "" || event.entity_id === ""? { width: '135px', background: 'rgb(255 226 0 / 26%)', color: 'black', fontWeight: 'bold'}:
                event.modified? { width: '135px', background: 'rgb(152 225 144 / 79%)', color: 'black', fontWeight: 'bold'} : { width: '135px'}, 
                class: 't-ll', 
                print: content => ( isEditable && positionIndex !== -1? 
                  event.isCustom?
                  <div className='tt-qq-0'>
                  <input type="text" placeholder={event.drill} style={{width: '118px'}} onChange={(e)=> handleEventType({drill: e.target.value, drillType: event.type}, index )} />
                  </div> 
                  :
                  <div className="period-type-simple-multi-selector">
                <div className="manage-p-table" >
                <Dropdown
                className="inte-00 field-type-dropdown "
                onSelect={(eventKey) => {
                  if (!eventKey) return;
                  noSave(true);
                  const selectedDrill = JSON.parse(eventKey) as { drill: string; drillType: string };
                  handleEventType( selectedDrill, index );
                }
                
              }
              >
                <Dropdown.Toggle id="dropdown-basic" disabled={!isEditable} style={{width: '120px'}}>
                  {text_truncate(content, 19)}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{maxHeight: '500px', overflowY: 'auto'}}>
                  {COMBINE_DRILLS[positionIndex].options.map((drill, index) => (
                    <Dropdown.Item eventKey={JSON.stringify({ drill: drill.drill, drillType: drill.drillType })} key={index}>{drill.drill}</Dropdown.Item>))}
                </Dropdown.Menu>
              </Dropdown>
              </div> 
              </div>
                :
                content
                )
              },
              {
                content: event.stTime,
                class: 't-ll',
                style: event.id == drillOne ? { width: '135px', background: 'rgb(8,164,252)', color: 'white', fontWeight: 'bold'} : event.id === drillTwo ? 
                { width: '135px', background: 'rgb(32, 36, 172)', color: 'white', fontWeight: 'bold'} :
                event.review? { width: '135px', background: '#d4f0ff', color: 'black', fontWeight: 'bold'}:
                event.esbid === "" || event.entity_id === ""? { width: '135px', background: 'rgb(255 226 0 / 26%)', color: 'black', fontWeight: 'bold'}: 
                event.modified? { width: '135px', background: 'rgb(152 225 144 / 79%)', color: 'black', fontWeight: 'bold'} : { width: '135px'},
                print: (content:number) => (
                  <Fragment>
                      <EditableTimeCombine
                        index={index}
                        editable={isEditable} time={content}
                        handleChange={(...args:[number, number, number ,boolean, number?]) => handleEventsTimeChange(event.id === drillOne 
                          ||event.id === 'drillOneend' ? 'drillOne' : 'drillTwo', 'stTime', ...args)}
                          timeIsWrong={!!startTimestampsMessages[index]}
                          rejectionMessage={startTimestampsMessages[index]}
                      />
                  </Fragment>
                )
              },
              {
                content: event.endTime && event.endTime !== -1 ? event.endTime : '' ,
                class: 't-ll',
                style: event.id == drillOne ? { width: '135px', background: 'rgb(8,164,252)', color: 'white', fontWeight: 'bold'} : event.id == drillTwo ? 
                { width: '135px', background: 'rgb(32, 36, 172)', color: 'white', fontWeight: 'bold'} : 
                event.review? { width: '135px', background: '#d4f0ff', color: 'black', fontWeight: 'bold'}:
                event.esbid === "" || event.entity_id === ""? { width: '135px', background: 'rgb(255 226 0 / 26%)', color: 'black', fontWeight: 'bold'}:
                event.modified? { width: '135px', background: 'rgb(152 225 144 / 79%)', color: 'black', fontWeight: 'bold'} :{ width: '135px'},
                print: (content:number) => (
                  <div className=''>
                  <Fragment>
                     {content === -1? '-' :
                      <EditableTimeCombine
                        index={index}
                        editable={isEditable} time={content}
                        handleChange={(...args:[number, number, number ,boolean, number?]) => handleEventsTimeChange(event.id == drillOne? 'drillOne' : 'drillTwo', 'endTime', ...args)}
                        timeIsWrong={!!endTimestampsMessages[index]}
                        rejectionMessage={endTimestampsMessages[index]}
                      />}
                  </Fragment>
                  </div>
                )
              },
              {  
                
                content:  meta.type === LIVE_PRACTICE ? (
                  <div >
                    {isEditable ?
                    (startTimestampsMessages[index] || endTimestampsMessages[index])?
                    (<>
                     <label className="ww-ee" >
                        <input
                        className="styled-checkbox"
                        id={"styled-checkbox-2"+event.event_id}
                        type="checkbox"
                        value="value2"
                        checked={isEditable}
                        onClick={() => {
                          setDisableStartOne(false);
                          setDisableStartTwo(false);
                          setEditDrillId({ event_id:'', event:{} });
                          setPracticeCopy(currentPractice);
                          setEventsValidation(DEFAULT_EVENT_VALIDATION_STATE);
                        }}
                        />
                        <label htmlFor={"styled-checkbox-2"+event.event_id} className="check-l" style={{top: '-5px'}} />
                      </label>
                    
                      <i className="mdi mdi-alert" style={{ color: '#D6151C', justifyContent: 'left', fontSize: 26, marginLeft:'11px'}} />
                 
                    </>)
                    :
                    (
                      <>
                        
                       
                        <label className="ww-ee" >
                        <input
                        className="styled-checkbox"
                        id={"styled-checkbox-2"+event.event_id}
                        type="checkbox"
                        value="value2"
                        checked={isEditable}
                        onClick={() => {
                          setEditDrillId({ event_id:'', event: {} });
                          setPracticeCopy(currentPractice);
                          setDisableStartOne(false);
                          setDisableStartTwo(false);
                          setTextSearchedEdited('');
                        }}
                        />
                        <label htmlFor={"styled-checkbox-2"+event.event_id} className="check-l" style={{top: '-5px'}} />
                      </label>
                      <button
                      style={{border: 'none', background: 'none', padding:'0', position: 'relative', fontSize:'21px', marginLeft:'25px', top: '1px'}}
                          className='mdi mdi-content-save'
                          onClick={() => {
                            setEditDrillId({ event_id:'', event: {} });
                            setDisableStartOne(false);
                            setDisableStartTwo(false);
                            setTextSearchedEdited('');
                            setCurrentPractice(practiceCopy);
                            if(event.event_id) updateCombineEvent(gameId, event, event.event_id, eventId, league!);
                          }}
                         
                        />
                        {
                          event.id === drillOne || event.id === drillTwo? (
                            null
                          )
                          :
                        (<button className="trash-00-combine" onClick={()=> {openConfirmationModal(event);}} 
                        style={event.id === drillOne || event.id === drillTwo?{ opacity: '0.5', pointerEvents: 'none' }:{color:'white'}}>
                        <img src="/assets/trash.svg" alt="" height="20px" />
                        </button>
                        )}
                      </>
                    ) : 
                    (
                      <div style={!!isInprogressOne || !!isInprogressTwo? { opacity: '0.5', pointerEvents: 'none' } : {}}>
                     
                     <label className="ww-ee">
                       <input
                        className="styled-checkbox"
                        id={"styled-checkbox-2"+event.event_id}
                        type="checkbox"
                        value="value2"
                        checked={isEditable}
                        onChange={() => {
                          setPracticeCopy(currentPractice);
                          setEditDrillId({ event_id: event.event_id? event.event_id : '', event:event });
                          setDisableStartOne(true);
                          setDisableStartTwo(true);
                        }}
                        />
                        <label htmlFor={"styled-checkbox-2"+event.event_id} className="check-l" />
                      </label>
                      </div>
                    )}
                  </div>
                ):
                (
                  null
                ),
                style: event.id == drillOne ? { background: 'rgb(8,164,252)', color: 'white', fontWeight: 'bold', width: '127px', top:''} : event.id == drillTwo ? 
                { width: '127px', background: 'rgb(32, 36, 172)', color: 'white', fontWeight: 'bold'} : 
                event.review? { width: '127px', background: '#d4f0ff', color: 'black', fontWeight: 'bold'}:
                event.esbid === "" || event.entity_id === ""? { width: '127px', background: 'rgb(255 226 0 / 26%)', color: 'black', fontWeight: 'bold'}:
                event.modified? { width: '127px', background: 'rgb(152 225 144 / 79%)', color: 'black', fontWeight: 'bold'} : { width: '127px'},
              }
            ],
            id: index.toString()
          }); 
        }
      });
  }
  const savable = isTMSavableCombine(eventsValidation);
  const [modalShow, setModalShow] = useState(0);
  const [selectedEvent, setSelectedEvent]=useState<CombineEventsType>();
  const openConfirmationModal = (event:CombineEventsType) => {
    setModalShow(3);
    setSelectedEvent(event);
  };

  const deleteEventModalContent = {
    headerContent: ' ',
    bodyContent: (
      <>
        Are you sure to delete the event?
          
      </>
    ),
    confirmContent: 'Yes, Delete Event'
  };
  return (
    <>
     <div>
         <div className="new-manage">
         { modalShow === 3 &&(
        <ConfirmationModalCombine
        show={modalShow}
        onHide={()=>{ setModalShow(0);}}
        modalConfig={{
          ...CONFIRMATION_MODAL_CONFIG,
          confirmClassName: 'm-delete-entity-confirm' } }
        modalContent={deleteEventModalContent }
        confirmAction={()=>{handleDeleteEvent(selectedEvent!);}}
      />)}
         <CombineHeader
            currentPractice={currentPractice}
            setCurrentPractice={setCurrentPractice}
            setIsUpdating={setIsUpdating}
            disableUpdate={drillTwoSt || drillOneSt}
          />
        </div>
        <div className="manage-head">
          Combine Logger
        </div>
        <Loader style={{ height: 'calc(100vh - 95px)' }}>
        <div className="combine-logger monitor" style={{ overflow: 'hidden auto' }}>
          <Row>
            <Col xs={12} md={3} lg={3} style={ meta.type !== LIVE_PRACTICE || !players ? { opacity: '0.5', pointerEvents: 'none' } : {}}>
              <div className="col-logger">
                <p>Drill 1</p>
                <Dropdown className="logger-dropdown" style={drillOneSt || !!isInprogressOne ? { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}}>
                <p>Position Group</p>
                  <Dropdown.Toggle id="dropdown-basic">
                    {positionOne}
                  </Dropdown.Toggle>
                  <div onClick={()=> changeCustomDrill(1)} style={{fontSize: '13px', cursor: 'pointer', fontFamily:'Roboto Condensed'}}>
                  <b style={isCustomDrillOne? {color:'#C8C7C7' }:{}}>Drill</b><b>/</b>
                  <b style={!isCustomDrillOne? {color:'#C8C7C7' }:{}}>Custom Drill</b>
                  </div>
                  <Dropdown.Menu>
                    {drillOnePosition}
                  </Dropdown.Menu>
                </Dropdown>
                {!isCustomDrillOne? 
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                   <Dropdown className="logger-drill-dropdown" style={drillOneSt || !!isInprogressOne || positionOne ==='SELECT POSITION' ? 
                    { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}}>
    
                      <Dropdown.Toggle id="dropdown-basic">
                        {text_truncate(currentDrillOne, 20)}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {drillOneFilter}
                      </Dropdown.Menu>
                    </Dropdown>
                 
                    <label className="ww-ee" style={drillOneSt || !!isInprogressOne ? { opacity: 0.5, cursor: 'default', pointerEvents: 'none'} : {}}>
                    <input
                    className="styled-checkbox"
                    id={"styled-checkbox-2 common-one"}
                    type="checkbox"
                    value="value2"
                    checked={comonDrillsSelectedOne}
                    onClick={() => {
                      if(!comonDrillsSelectedOne && currentPosOne !== 10){
                        setCurrentDrillOne('SELECT DRILL');
                      }
                      setComonDrillsSelectedOne(!comonDrillsSelectedOne);
                      
                    }}
                    />
                    <label htmlFor={"styled-checkbox-2 common-one"} className="check-l"/>
                    <span style={{fontSize: '13px', cursor: 'pointer', fontFamily:'Roboto Condensed', fontWeight:'bold', marginLeft:'5px'}}>Lock Drills</span>
                  </label>
                  
                  </div>
                    :
                    <div className='tt-qq-0' style={drillOneSt || !!isInprogressOne || positionOne ==='SELECT POSITION' ? 
                      { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF', height: '35px' }:{height: '35px'}}>
                      <input type="text" value={customDrillOneAux} placeholder='Input Drill Name' style={{width: '140px',height: '32px'}} onChange={(e) =>handleDrillOneChange(e.target.value)} /> 
                    </div>
                    
              }
             
                <br/>
                <h1>{!drillOneLabel && currentDrillOne === 'SELECT DRILL' || currentDrillOne === '' ? '-' :text_truncate(currentDrillOne,19)}</h1>
                <button style={currentDrillOne === 'SELECT DRILL' || currentDrillOne === '' || disableStartOne || isUpdating? 
                { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}} className="start" onClick={()=>{
                  if(drillOneSt || !!isInprogressOne){
                    setDrOneJerseyNumber('');
                  }
                    handleSaveClick(currentDrillOne,  drillOneSt || !!isInprogressOne? 'drillOneend' : 'drillOnest' );
                  }}>
                  { drillOneSt || !!isInprogressOne? 'End' : 'Start'}
                </button>
              </div>
             <div className="col-logger">
              <p>Jersey Number</p>
              <h1>{drOneJerseyNumber === ''? '-' : drOneJerseyNumber}</h1>
              <div style={drillOneSt || !!isInprogressOne || !players ? { opacity: '0.5', pointerEvents: 'none' } : {}}>
              <button style={drOneJerseyNumber === ''?{ opacity: '0.5', pointerEvents: 'none' }:{}} className='clear' id='clear' onClick={clearDrOneJersey}>Clear</button>
                  <div className='keypad' >
                    <button className='number' name='1' onClick={handleUpdateDrOneJersey}>1</button>
                    <button className='number' name='2' onClick={handleUpdateDrOneJersey}>2</button>
                    <button className='number' name='3' onClick={handleUpdateDrOneJersey}>3</button>
                    <button className='number' name='4' onClick={handleUpdateDrOneJersey}>4</button>
                    <button className='number' name='5' onClick={handleUpdateDrOneJersey}>5</button>
                    <button className='number' name='6' onClick={handleUpdateDrOneJersey}>6</button>
                    <button className='number' name='7' onClick={handleUpdateDrOneJersey}>7</button>
                    <button className='number' name='8' onClick={handleUpdateDrOneJersey}>8</button>
                    <button className='number' name='9' onClick={handleUpdateDrOneJersey}>9</button>
                    <button className='number-cero' name='0' onClick={handleUpdateDrOneJersey}>0</button>                    
                  </div>
              </div>
             </div>
            </Col>
            
            <Col xs={12} md={6} lg={6}>
              <div className='combine-table'>
              <Loader forceScope='COMBINE_LOGER_TABLE' forceLoader={isUpdating}>
                <Table
                  headers={headers}
                  rows={rows.reverse()}
                  default={{orderColumn: 3}}
                  forceScope={`COMBINE_LOGER_TABLE`}
                />
                </Loader>
              </div>
              
            </Col>
            <Col xs={12} md={3} lg={3} style={ meta.type !== LIVE_PRACTICE || !players? { opacity: '0.5', pointerEvents: 'none' } : {}}>
              <div className="col-logger">
                <p>Drill 2</p>
                <Dropdown className="logger-dropdown" style={drillTwoSt || !!isInprogressTwo ? { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}}>
                <p>Position Group</p>
                  <Dropdown.Toggle id="dropdown-basic">
                    {positionTwo}
                  </Dropdown.Toggle>
                  <div onClick={()=> changeCustomDrill(2)} style={{fontSize: '13px', cursor: 'pointer',  fontFamily:'Roboto Condensed' }}>
                  <b style={isCustomDrillTwo? {color:'#C8C7C7' }:{}}>Drill</b><b>/</b>
                  <b style={!isCustomDrillTwo? {color:'#C8C7C7' }:{}}>Custom Drill</b>
                  </div>
                  <Dropdown.Menu>
                    {drillTwoPosition}
                  </Dropdown.Menu>
                </Dropdown>
                {!isCustomDrillTwo? 
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                     <Dropdown className="logger-drill-dropdown">
                     <Dropdown.Toggle id="dropdown-basic" style={drillTwoSt || !!isInprogressTwo || positionTwo ==='SELECT POSITION'?
                      { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}}>
                       {text_truncate(currentDrillTwo, 20)}
                     </Dropdown.Toggle>
                     <Dropdown.Menu>
                       {drillTwoFilter}
                     </Dropdown.Menu>
                   </Dropdown>
                   <label className="ww-ee" style={drillTwoSt || !!isInprogressTwo ? { opacity: 0.5, cursor: 'default', pointerEvents: 'none'} : {}}>
                    <input
                    className="styled-checkbox"
                    id={"styled-checkbox-2 common"}
                    type="checkbox"
                    value="value2"
                    checked={comonDrillsSelectedTwo}
                    onClick={() => {
                      if(!comonDrillsSelectedTwo && currentPosTwo !== 10){
                        setCurrentDrillTwo('SELECT DRILL');
                      }
                      setComonDrillsSelectedTwo(!comonDrillsSelectedTwo);
                      
                    }}
                    />
                    <label htmlFor={"styled-checkbox-2 common"} className="check-l"/>
                    <span style={{fontSize: '13px', cursor: 'pointer', fontFamily:'Roboto Condensed', fontWeight:'bold', marginLeft:'5px'}}>Lock Drills</span>
                  </label>
                   </div>
                    :
                    <div className='tt-qq-0' style={drillTwoSt || !!isInprogressTwo || positionTwo ==='SELECT POSITION' ? 
                      { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF', height: '35px' }:{height: '35px'}}>
                      <input type="text" value={customDrillTwoAux} placeholder='Input Drill Name' style={{width: '140px', height: '32px'}} onChange={(e) =>handleDrillTwoChange(e.target.value)} /> 
                    </div>  
              }
                <br/>
                <h1>{!drillTwoLabel && currentDrillTwo === 'SELECT DRILL' || currentDrillTwo === ''? '-' : text_truncate(currentDrillTwo,19)}</h1>
                <button className="start-01" style={currentDrillTwo === 'SELECT DRILL' || currentDrillTwo === '' || disableStartTwo || isUpdating? 
                { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}}
                onClick={()=>{
                  if( drillTwoSt || !!isInprogressTwo){
                    setDrTwoJerseyNumber('');
                  }
                  handleSaveClick(currentDrillTwo, drillTwoSt || !!isInprogressTwo? 'drillTwoend' : 'drillTwost');
                }}>
                  { drillTwoSt || !!isInprogressTwo? 'End' : 'Start'}
                </button>
              </div>
              <div className="col-logger">
              <p>Jersey Number</p>
              <h1>{drTwoJerseyNumber === ''? '-' : drTwoJerseyNumber}</h1>
              <div style={drillTwoSt || !!isInprogressTwo || !players? { opacity: '0.5', pointerEvents: 'none' } : {}}>
              <button style={drTwoJerseyNumber === ''?{ opacity: '0.5', pointerEvents: 'none' }:{}}className='clear-T' id='clear' onClick={clearDrTwoJersey}>Clear</button>
                  <div className='keypad'>
                    <button className='number-T' name='1' onClick={handleUpdateDrTwoJersey}>1</button>
                    <button className='number-T' name='2' onClick={handleUpdateDrTwoJersey}>2</button>
                    <button className='number-T' name='3' onClick={handleUpdateDrTwoJersey}>3</button>
                    <button className='number-T' name='4' onClick={handleUpdateDrTwoJersey}>4</button>
                    <button className='number-T' name='5' onClick={handleUpdateDrTwoJersey}>5</button>
                    <button className='number-T' name='6' onClick={handleUpdateDrTwoJersey}>6</button>
                    <button className='number-T' name='7' onClick={handleUpdateDrTwoJersey}>7</button>
                    <button className='number-T' name='8' onClick={handleUpdateDrTwoJersey}>8</button>
                    <button className='number-T' name='9' onClick={handleUpdateDrTwoJersey}>9</button>
                    <button className='number-cero-T' name='0' onClick={handleUpdateDrTwoJersey}>0</button>
                  </div>
              </div>
             </div>      
            </Col>
          </Row>
     </div>
     </Loader>
    </div>
    </>
  );
};

export default CombineLogger;
